@if (vonqContractsService.validContracts().length > 0) {
  <h5>
    {{ 'company-tool.snippets.contract-selector.title' | transloco }}
  </h5>
  <div class="table-wrapper">
    <p-table
      id="job-posting-publish-recommended-channels"
      class="jobplatforms"
      [value]="vonqContractsService.validContracts()"
    >
      <ng-template #header>
        <tr>
          <th style="width: 10%"></th>
          <th style="width: 80%">
            {{ 'company-tool.snippets.contract-selector.name-label' | transloco }}
          </th>
          <th style="width: 10%" class="text-center">
            {{
              'company-tool.views.jobs.posting.sections.publication.table.headers.publish'
                | transloco
            }}
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-contract>
        <tr>
          <td>
            <img
              [src]="contract.channel.logo_square_url[0].url"
              [alt]="'Logo - ' + contract.title"
              loading="lazy"
              width="30px"
            />
          </td>
          <td>
            <b>{{ contract.product.title }}</b> ({{ contract.alias }})
          </td>
          <td class="text-center" id="job-posting-publish-channels-check">
            <input
              type="checkbox"
              [checked]="selectedContracts().includes(contract)"
              (change)="onContractSelectionChange(contract)"
            />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}
